import catalogue from "./facility-types-schema.json";

export const setupFacilityTypes = catalogue.types.map((type) => ({
  id: type.nativeCode,
  text: type.label.en,
  labels: type.label,
}));

export function facilityTypeLabel(
  type: { text: string; labels?: { en: string; ar: string } },
  language: string,
) {
  const labels =
    type.labels ||
    setupFacilityTypes.find((value) => value.text === type.text)?.labels;
  return labels?.[language.startsWith("ar") ? "ar" : "en"] || type.text;
}
